import { render, staticRenderFns } from "./AssetProductList.vue?vue&type=template&id=b3e1a5ac&"
import script from "./AssetProductList.vue?vue&type=script&lang=js&"
export * from "./AssetProductList.vue?vue&type=script&lang=js&"
import style0 from "./AssetProductList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports